import qs from 'qs';
import get from 'lodash/get';

export function createQueryString(params) {
  console.log("createQueryString params", params)
  const queryString = qs.stringify(params, {
    arrayFormat: 'brackets',
    encodeValuesOnly: true,
  });
  return queryString;
}

export function parseQueryParams(location) {
  // Handle both location objects and search string arguments
  const path =
    typeof location === 'string' ? location : get(location, 'search', '');
  // Make sure function strips ? symbol if present
  const cleanPath = path.startsWith('?') ? path.substring(1) : path;
  // Parse
  const queryParams = qs.parse(cleanPath, {
    decoder: str => {
      if (str === '') {
        return '';
      }
      // eslint-disable-next-line no-restricted-globals
      //     if (!isNaN(str)) {
      //       return parseFloat(str);
      //     }
      if (str === 'true' || str === 'false') {
        return str === 'true';
      }
      return decodeURIComponent(str);
    },
  });
  return queryParams || {};
}



// WEBPACK FOOTER //
// ./src/utils/queryStringUtils.js